{
  "firmwares": {
    "navigation_title": "Firmware",
    "title": "Firmware",
    "empty_list": "No firmwares available",
    "rollout": "Rollout Firmware",
    "select_channel": "Select Channel...",
    "select_serials": "Choose Serials..."
  }
}
